import { isoCodes } from '@/constants/countries'
import {
  isBoolean,
  isNumber,
  isString,
  isArray,
  hasObjectConstructor,
  isNull,
  isUndefined,
} from '@/utils/checkers/validation'

export const isValidFlag = (code: string): boolean => {
  return isoCodes.includes(code)
}

export const isValidEmail = (email: string): boolean => {
  const regexToTest =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-z\-\d]+\.)+[a-z]{2,}))$/i

  return regexToTest.test(email)
}

export const isValidUrl = ($url: string): boolean => {
  const regex =
    /^(?:(?:(?:https?)?:)?\/\/)?(?:\S+@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[01])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4])|(?:[a-z\u00a1-\uffff\d]-*)*[a-z\u00a1-\uffff\d](?:\.(?:[a-z\u00a1-\uffff\d]-*)*[a-z\u00a1-\uffff\d])*\.[a-z\u00a1-\uffff]{2,})(?::\d{2,5})?(?:[/?#]\S*)?$/i
  return regex.test($url)
}

export const isValidLocalhostUrl = ($url: string): boolean => {
  const regex = /^https?:\/\/\w+(:\d*)?\/?(\/[.\w]*)*$/
  return regex.test($url)
}

/**
 * @function isValidTranslation
 * @param  {Object} obj
 * @return {Boolean}
 */

export const isValidTranslation = (obj: unknown): boolean => {
  if (isNull(obj) || isUndefined(obj)) {
    return false
  }

  if (
    isArray(obj) ||
    isString(obj) ||
    isBoolean(obj) ||
    hasObjectConstructor(obj)
  ) {
    return true
  }

  if (isNumber(obj)) {
    return true
  }

  if (hasObjectConstructor(obj)) {
    return true
  }

  return Object.keys(obj).length === 0
}

export const isTagInvalid = (tag: string = ''): boolean => {
  return tag.includes(',')
}
